'use client';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { signOut } from 'next-auth/react';

import { api } from '@/api/api';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface IUserNav {
  refreshToken: string;
  token: string;
  name: string;
  email: string;
}

export function UserNav({ token, name, email }: IUserNav) {
  const router = useRouter();

  const getInitial = (name: string) => {
    if (name.length <= 0) return;
    const words = name.split(' ');
    const initials = words.map((word) => word[0].toUpperCase());
    return initials.join('');
  };
  const nameLetter = getInitial(name);

  const logout = async () => {
    try {
      const response = await fetch(`${api.baseURL}/api/v1/user/logout`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Baerer ${token}`,
        },
        method: 'POST',
      });

      if (response.status >= 400) {
        await signOut();
        router.replace('/signin');
      }
    } catch {
      (err: Error) => console.log(err);
    }
    await signOut();
    router.replace('/signin');
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="relative h-8 w-8 rounded-full">
          <Avatar className="h-9 w-9">
            <AvatarImage src="" alt="Minha foto" />
            <AvatarFallback>{nameLetter}</AvatarFallback>
          </Avatar>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="end" forceMount>
        <DropdownMenuLabel className="font-normal">
          <div className="flex flex-col space-y-1">
            <p className="text-sm font-medium leading-none">{name}</p>
            <p className="text-xs leading-none text-muted-foreground">
              {email}
            </p>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          {/* <DropdownMenuItem>Perfil</DropdownMenuItem>
          <DropdownMenuItem>Billing</DropdownMenuItem> */}
          <Link href={'/profile'}>
            <DropdownMenuItem>Configurações</DropdownMenuItem>
          </Link>
          {/* <Link href={'/user/create'}>
            <DropdownMenuItem>Novo Usuário</DropdownMenuItem>
          </Link> */}
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <Link
          href={'#'}
          onClick={() => {
            logout();
          }}
        >
          <DropdownMenuItem>Sair</DropdownMenuItem>
        </Link>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
